
import axiosInstance from 'axios-config';

export const getAzureLocation = async () => {
  try {
    const { data } = await axiosInstance.get('/login/');
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getCredential = async (azureParams) => {
  try {
    const { data } = await axiosInstance.post('/login/', azureParams);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};